import styled from "styled-components";

export const InputRegisTypeWidgetStyled = styled.div`
  margin-bottom: 30px;
  .btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 5px;
    .btn_history {
      padding: 0 20px;
      width: 100%;
      max-width: 317px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: transparent;
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
      .content {
        display: flex;
        align-items: center;
        column-gap: 15px;
      }
      .arrow_next {
        font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      }
    }
    .line_between {
      margin: 20px 0;
      height: 1px;
      width: 317px;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      opacity: 0.6;
    }
  }
  .input_regis_type1_container {
    display: flex;
    column-gap: 12px;
    .btn_inr_item {
      flex: 1;
      border-radius: 9px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_4}21;
      padding: 12px 10px;
      display: flex;
      align-items: center;
      background: ${({ theme }) => theme.COLORS.PURPLE_3}21;
      cursor: pointer;
      &.active {
        border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_4}73;
        background: ${({ theme }) => theme.COLORS.PURPLE_3}73;
      }
      .inr_icon_wrap {
        margin-left: 15px;
        margin-right: 12px;
      }
      .inr_label {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
    }
    .btn_inr_col {
      flex: 1;
    }
  }

  .input_regis_type2_container {
    .btn_inr_item {
      border-radius: 9px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_4}21;
      padding: 12px 10px;
      display: flex;
      align-items: center;
      background: ${({ theme }) => theme.COLORS.PURPLE_3}21;
      cursor: pointer;
      &.mb_10 {
        margin-bottom: 10px;
      }
      &.active {
        border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_4}73;
        background: ${({ theme }) => theme.COLORS.PURPLE_3}73;
      }
      &.add {
        padding: 12px 10px 12px 26px;
      }
      .inr_icon_wrap {
        margin-left: 15px;
        margin-right: 12px;
      }
      .inr_label {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }
  }

  .input_regis_type3_container {
    margin-bottom: 50px;
    .btn_history {
      margin: auto;
      margin-bottom: 16px;
      border-radius: 24px;
      padding-left: 30px;
      padding-right: 13px;
      width: 100%;
      max-width: 358px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
      .content {
        display: flex;
        align-items: center;
        column-gap: 15px;
        white-space: nowrap;
        .ct_icon_wrap {
          width: 24px;
        }
      }
    }
    .line_between {
      width: 317px;
      margin: 20px 0;
      height: 1px;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      opacity: 0.6;
    }
  }

  .input_regis_type4_container {
    display: flex;
    align-items: center;
    column-gap: 16px;
    .btn_type4_item {
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      padding-bottom: 7px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 14px;
      cursor: pointer;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      &.active {
        border-bottom: 4px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .input_regis_type3_container {
      .btn_history {
        height: 44px;
      }
    }
  }
`;

export const FormContainer = styled.div`
  border-radius: 12px;
  padding: 30px 36px;
  max-width: 370px;
  width: 100%;
  max-height: 80vh;
  overflow: auto;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  color: ${({ theme }) => theme.COLORS.GRAY_2};
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
`;
